// @flow
export const CREATE_COURSE_FORM: string = "createCourseForm";

// modes
export const NONE: string = "NONE";
export const CREATE: string = "CREATE";
export const EDIT: string = "EDIT";
export const NO_MODE: string = "NO_MODE";
